
  module.exports =
  {

    issues:
    {

      _init: function ()
      {

        APPLICATION.PlotIssue.onSelectCompany()

        APPLICATION._APPLICATION.search($('.js-url'))

      }

    },

    issueList:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#plots', 'PlotIssue', 'issueList')
      }

    },

    history:
    {

      _init: function ()
      {

        APPLICATION.PlotIssue.onSelectCompany()

        APPLICATION._APPLICATION.search($('.js-url'))

      }

    },

    historyList:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#plots', 'PlotIssue', 'historyList')
      }

    },

    resolve:
    {

      _init: function ()
      {

        $('#previous_details').not('.js-ignore').change(function ()
        {

          var checked = this.checked

          $('[data-previous]').each(function ()
          {

            if (checked)
            {
              $(this).val($(this).data('previous'))
            }

            else if ($(this).val() == $(this).data('previous'))
            {
              $(this).val('')
            }

          }
          )

        }
        ).addClass('js-ignore')

        var plot_issue_log_id = $('#plot_issue_log_id').val()

        $('#modal-calendar').not('.js-ignore').click(function ()
        {
  
          var form = $(this).closest('form').serialize()
  
          APPLICATION._datepicker = function (date)
          {
  
            form += '&reported_date=' + date
  
            APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'plot-issue/resolve/' + plot_issue_log_id + '?' + form, 'PlotIssue', 'resolve')
  
          }
  
          var parts = $('#reported_date').val().split('/')
  
          $('#calendar').data(APPLICATION._DATA_PREFIX + 'modal', APPLICATION._PATH_PREFIX + 'calendar/month/' + parts[2] + '/' + parts[1] + '?modal=1&date=' + parts[2] + '-' + parts[1] + '-' + parts[0]).trigger('click')
  
        }
        ).addClass('js-ignore')

      }

    },

    resolved:
    {

      _init: function ()
      {

        APPLICATION.PlotIssue.onSelectCompany()

        APPLICATION._APPLICATION.search($('.js-url'))

      }

    },

    resolvedList:
    {

      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#plots', 'PlotIssue', 'resolvedList')
      }

    },

    onSelectCompany: function ()
    {
  
      $('#company_id').not('.js-ignore').change(function ()
      {

        var company_id = $(this).val()

        var development = $('#development_id')

        if ('' === company_id)
        {
          development.next('.dropdown-menu').html('')
        }

        else
        {

          APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/coins-dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'coinsDropdown', function ()
          {

            if ('' !== development.val())
            {
              APPLICATION._APPLICATION.search($('.js-url'))
            }

          }
          )

        }

      }
      ).addClass('js-ignore').trigger('change')

    }

  }